import { render, staticRenderFns } from "./vue-flow-editor-icon.vue?vue&type=template&id=45d4eb98&scoped=true&"
import script from "./vue-flow-editor-icon.vue?vue&type=script&lang=js&"
export * from "./vue-flow-editor-icon.vue?vue&type=script&lang=js&"
import style0 from "./vue-flow-editor-icon.vue?vue&type=style&index=0&id=45d4eb98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d4eb98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/erp-flexible-web21_zo1Z/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45d4eb98')) {
      api.createRecord('45d4eb98', component.options)
    } else {
      api.reload('45d4eb98', component.options)
    }
    module.hot.accept("./vue-flow-editor-icon.vue?vue&type=template&id=45d4eb98&scoped=true&", function () {
      api.rerender('45d4eb98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/g6-canvas/components/vue-flow-editor-icon.vue"
export default component.exports